import React from 'react';
import { Link } from 'react-router-dom';

export default function Paginate({ currentPage=1, totalPages=1, pathname="/", search="" }) {
  const getPages = () => {
    let pages = [];
    switch (totalPages) {
      case 1:
        pages = [1];
        break;
      case 2:
        pages = [1,2];
        break;
      case 3:
        pages = [1,2,3];
        break;
      case 4:
        pages = [1,2,3,4];
        break;
      case 5:
        pages = [1,2,3,4,5];
        break;
      case 6:
        pages = [1,2,3,4,5,6];
        break;
      default:
        if(currentPage < 3){
          pages = [1,2,3,'...',totalPages];
        }else if(currentPage === 3){
          pages = [1,2,3,4,'...',totalPages];
        }else if(currentPage === 4){
          pages = [1,'...',3,4,5,'...',totalPages];
        }else{
          if(currentPage + 2 < totalPages)
            pages = [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
          else if(currentPage + 1 < totalPages)
            pages = [1, '...', currentPage - 1, currentPage, currentPage + 1, totalPages];
          else if(currentPage + 1 === totalPages)
            pages = [1, '...', currentPage - 1, currentPage, totalPages];
          else
            pages = [1, '...', currentPage - 2, currentPage - 1, totalPages];
        }
        break;
    }

    return pages;
  }

  const setPage = (p) => {
    if(search === "")
      return "?page=" + p;
    else
      if(/page=\d+/.test(search) === false)
        return search + '&page=' + p;
      else
        return search.replace(/^(.*)(page=\d+)(.*)$/,"$1page=" + p + "$3");
  }

  return (
    totalPages > 1 &&
    <div className='paginate'>
      <ul>
        { currentPage > 1 &&
        <li><Link to={ pathname + setPage(currentPage - 1) } className='page_item'><i className='fa fa-angle-left'></i></Link></li>
        }
        { getPages().map((p,i) => {
          return(
            <li key={ i }>
              { (p === '...' || p === currentPage) ? <span className={ `page_item${ p !== '...' ? ' active' : '' }` }>{ p }</span> : <Link to={ pathname + setPage(p) } className='page_item'>{ p }</Link> }
            </li>
          )
        }) }
        { currentPage < totalPages &&
        <li><Link to={ pathname + setPage(currentPage + 1) } className='page_item'><i className='fa fa-angle-right'></i></Link></li>
        }
      </ul>
    </div>
  )
}
